module.exports = __webpack_public_path__ + "static/media/delete.d0c596a8.svg";